import { render } from "./BadgeYear.vue?vue&type=template&id=326d916d&scoped=true"
import script from "./BadgeYear.vue?vue&type=script&lang=js"
export * from "./BadgeYear.vue?vue&type=script&lang=js"

import "./BadgeYear.vue?vue&type=style&index=0&id=326d916d&scoped=true&lang=css"

import exportComponent from "/var/www/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-326d916d"]])

export default __exports__